const Index = () => import('./index.vue');
const AccountBalances = () => import('./balances.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/accounts',
        name: 'AccountsLogin',
        component: Index
    },
    {
        path: '/account-balances',
        component: AccountBalances
    },
    {
        path: '/new-account',
        name: 'NewAccountPage',
        component: CreatePage
    },
    {
        path: '/account/:id',
        component: ViewPage
    }
]